// extracted by mini-css-extract-plugin
export default {"content":"portfolio-module--content--3NBcp"};